import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MouseTrail } from "@stichiboi/react-elegant-mouse-trail";
import Header from './Header/Header';
import Home from './Home/Home';
import ClonesInfo from './ClonesInfo/ClonesInfo';
import PuntajesInfo from './PuntajesInfo/PuntajesInfo';
import AcercaDe from './AcercaDe/AcercaDe';
import Contacto from './Contacto/Contacto';
import SmartbookAI from './SmartbookAI/SmartbookAI';
import Perfil from "./Perfiles/Perfiles";
import PoliticaPrivacidad from './PoliticaPrivacidad/PoliticaPrivacidad';
import TerminosCondiciones from './TerminosCondiciones/TerminosCondiciones';


import styles from './App.module.css';

function App() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  // No permitir el scroll horizontal, bloquear
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
  }, []);

 return (
   <Router>  
        <Header />
      <main className={styles.body}>
        <MouseTrail className={styles.MouseTrail} strokeColor={"#3878F9"} lineWidthStart={15}/>
        <Routes> 
          <Route path="/" element={<Home />} />
          <Route path="/acerca-de" element={<AcercaDe />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/clones-info" element={<ClonesInfo />} />
          <Route path="/calificador-info" element={<PuntajesInfo />} />
          <Route path="/smartbook-AI-info" element={<SmartbookAI />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
          <Route path="/:perfil-nombre" element={<Perfil />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
